import { useCallback, useEffect, useRef } from 'react';

/**
 * Prevents re-renders or unsubscribe/subscribe invocations on heavily updated components.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useEventCallback(fn, deps) {
  const ref = useRef(() => {
    throw new Error('Cannot call an event handler while rendering.');
  });
  useEffect(() => {
    ref.current = fn;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fn, ...deps]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback((...args) => ref.current(...args), [ref]);
}